/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC } from "react";
import { FooterContainer, MoreIcon, ShowMoreLinkContainer } from "./styles";
import useSettingsModal from "../useSettingsModal";
import { useFormatMsg } from "../../../../../../hooks/useFormatMsg";

export type ListFooterProps = {
  toggleIsExpanded: () => void;
  isExpanded: boolean;
  croppedMsgCount: number;
};

const ListFooter: FC<ListFooterProps> = ({
  toggleIsExpanded,
  isExpanded,
  croppedMsgCount,
}) => {
  const formatMsg = useFormatMsg();

  const [settingsModal, settingsModalToggle] = useSettingsModal();

  const linkText = isExpanded
    ? formatMsg("common.show_less")
    : formatMsg("common.and_x_more", { x: croppedMsgCount });

  return (
    <FooterContainer data-cy="list-footer">
      {croppedMsgCount > 0 && (
        <ShowMoreLinkContainer onClick={toggleIsExpanded} data-cy="show-more">
          <span>{linkText}</span>
          <MoreIcon active={isExpanded} />
        </ShowMoreLinkContainer>
      )}
      {settingsModalToggle}
      {settingsModal}
    </FooterContainer>
  );
};

export default ListFooter;
